<template>
  <div>
    <span v-if="isMerchant('ios')"><i class="fa fa-apple"></i> Apple</span>
    <span v-if="isMerchant('android')"><i class="fa fa-android"></i> Google</span>
    <span v-if="isMerchant('ndrive')"><i class="fa fa-gift"></i> NDrive</span>
    <span v-if="isMerchant('cybersource')"><i class="fa fa-money"></i> Cybersource</span>
    <span v-if="isMerchant('manual')"><i class="fa fa-user"></i> Manual</span>
  </div>
</template>

<script>
import merchants from 'services/merchants'

export default {
  name: 'merchant',
  props: ['merchant'],
  methods: {
    isMerchant (name) {
      return merchants.is(this.merchant, name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Merchant.vue